<template>
	<div class="account-config-wrapper global-card">
		<div class="account-config-card" style="margin-top: 20px;padding: 20px 32px;">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 20px;">合作企业</div>
				<el-select v-model="companyvalue" placeholder="请选择合作企业" style="width: 400px;">
					<el-option v-for="item in companyData" :key="item.id" :label="item.companyInfo.qichacha_name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
		</div>
		<bread-crumb />
		<div class="account-config-card">
			<el-tabs :tab-position="tabPosition" style="height: 700px;overflow:auto" @tab-click="handleClick">
				<el-tab-pane label="拜访">
					<div class="formcontent">
						<div class="left">
							<div class="title">表单元素</div>
							<div class="from">
								<div v-for="(item,index) in formdata" :class="n==index?'active':''"
									@click="check(index,item)">
									<span>{{item.name}}</span>
									<i class="el-icon-arrow-right"></i></div>
							</div>
						</div>
						<div class="right">
							<div class="title">属性设置</div>
							<div>
								<el-form ref="form" :model="form" label-width="80px">
									<el-form-item label="主题名称">
										<el-input v-model="form.name"></el-input>
									</el-form-item>
									<el-form-item label="默认填值" v-if="show">
										<el-input v-model="form.default"></el-input>
									</el-form-item>
									<el-form-item label="必填字段">
										<el-switch v-model="form.required"></el-switch>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit">保存</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>

				</el-tab-pane>

				<el-tab-pane label="调研">
					<div class="formcontent">
						<div class="left">
							<div class="title">表单元素</div>
							<div class="from">
								<div v-for="(item,index) in formdata1" :class="n1==index?'active':''"
									@click="check1(index,item)"><span>{{item.name}}</span>
									<i class="el-icon-arrow-right"></i></div>
							</div>
						</div>
						<div class="right">
							<div class="title">属性设置</div>
							<div>
								<el-form ref="form" :model="form1" label-width="80px">
									<el-form-item label="主题名称">
										<el-input v-model="form1.name"></el-input>
									</el-form-item>
									<el-form-item label="默认填值" v-if="show1">
										<el-input v-model="form1.default"></el-input>
									</el-form-item>
									<el-form-item label="必填字段">
										<el-switch v-model="form1.required"></el-switch>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit">保存</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="科室会">
					<div class="formcontent">
						<div class="left">
							<div class="title">表单元素</div>
							<div class="from">
								<div v-for="(item,index) in formdata2" :class="n2==index?'active':''"
									@click="check2(index,item)"><span>{{item.name}}</span>
									<i class="el-icon-arrow-right"></i></div>
							</div>
						</div>
						<div class="right">
							<div class="title">属性设置</div>
							<div>
								<el-form ref="form" :model="form2" label-width="80px">
									<el-form-item label="主题名称">
										<el-input v-model="form2.name"></el-input>
									</el-form-item>
									<el-form-item label="默认填值" v-if="show1">
										<el-input v-model="form2.default"></el-input>
									</el-form-item>
									<el-form-item label="必填字段">
										<el-switch v-model="form2.required"></el-switch>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit">保存</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>


				</el-tab-pane>
				<el-tab-pane label="沙龙会">
					<div class="formcontent">
						<div class="left">
							<div class="title">表单元素</div>
							<div class="from">
								<div v-for="(item,index) in formdata3" :class="n3==index?'active':''"
									@click="check3(index,item)"><span>{{item.name}}</span>
									<i class="el-icon-arrow-right"></i></div>
							</div>
						</div>
						<div class="right">
							<div class="title">属性设置</div>
							<div>
								<el-form ref="form" :model="form3" label-width="80px">
									<el-form-item label="主题名称">
										<el-input v-model="form3.name"></el-input>
									</el-form-item>
									<el-form-item label="默认填值" v-if="show1">
										<el-input v-model="form3.default"></el-input>
									</el-form-item>
									<el-form-item label="必填字段">
										<el-switch v-model="form3.required"></el-switch>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit">保存</el-button>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>

				</el-tab-pane>
				
			</el-tabs>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				show1: false,
				show2: false,
				show3: false,
				n: 0,
				n1: 0,
				n2: 0,
				n3: 0,
				type: 'payvisit',
				form: {
					name:'',
					default:'',
					required:false
				},
				form1: {
					name:'',
					default:'',
					required:false
				},
				form2: {
					name:'',
					default:'',
					required:false
				},
				form3: {
					name:'',
					default:'',
					required:false
				},
				tabPosition: 'left',
				companyvalue: '',
				companyData: [],
				formdata: [{
					name: '医生姓名'
				}, {
					name: '医院名称'
				}, {
					name: '拜访科室'
				}, {
					name: '拜访名称'
				}, {
					name: '拜访开始时间'
				}, {
					name: '拜访结束时间'
				}, {
					name: '拜访目的'
				}, {
					name: '学习资料'
				}, {
					name: '签到打卡'
				}, {
					name: '现场照片'
				}, {
					name: '医生反馈'
				}],
				formdata1: [{
					name: '医生姓名'
				}, {
					name: '医院名称'
				}, {
					name: '调研科室'
				}, {
					name: '调研名称'
				}, {
					name: '调研开始时间'
				}, {
					name: '调研结束时间'
				}, {
					name: '学习资料'
				}, {
					name: '签到打卡'
				}, {
					name: '调研表照片'
				}],
				
				formdata2: [{
					name: '会议名称'
				}, {
					name: '会议开始时间'
				}, {
					name: '会议结束时间'
				}, {
					name: '参会人数'
				}, {
					name: '举办医院'
				}, {
					name: '参会科室'
				}, {
					name: '备注'
				}, {
					name: '学习资料'
				}, {
					name: '签到打卡'
				}, {
					name: '签到表'
				}, {
					name: '现场照片'
				}, {
					name: '会议通知/邀请函'
				}, {
					name: '会议记录以及报告上传'
				}],
				formdata3: [{
					name: '会议名称'
				}, {
					name: '会议开始时间'
				}, {
					name: '会议结束时间'
				}, {
					name: '会议城市'
				}, {
					name: '参会人数'
				}, {
					name: '参会医院(可多选)'
				}, {
					name: '参会科室'
				}, {
					name: '备注'
				}, {
					name: '学习资料'
				}, {
					name: '签到打卡'
				}, {
					name: '签到表'
				}, {
					name: '现场照片'
				}, {
					name: '会议通知/邀请函'
				}, {
					name: '上传会议报告'
				}]

			};
		},
		mounted() {
			this.getCompanyList()
			this.form.name = this.formdata[0].name
		},
		methods: {
			// 获取合作企业
			async getCompanyList() {
				let result = await this.$http.post('/Company/getCooperationCompanyList');
				if (result.data.status === 1) {
					this.companyData = result.data.data.data_list;
					this.companyvalue = result.data.data.data_list[0].id
					this.getPromoterData()
				}
			},

			async getPromoterData() {
				
				let result = await this.$http.post('/ExecuteRule/getRule', {
					company_id: this.companyvalue,
					type: this.type,
				});
				
				if (result.data.status === 1) {
					if (result.data.data != null) {
						this.info = result.data.data
					} else {
						this.info = {
							id: null,
							value: {
								other_rule: {
									continuous_task_interval_time: 0
								}
							}
						}
					}

				}
			},
			onSubmit() {

			},
			check(i, obj) {
				if (obj.name == '拜访名称') {
					this.show = true
				} else {
					this.show = false
				}
				this.n = i
				this.form.name = obj.name
			},
			check1(i, obj) {
				if (obj.name == '调研名称') {
					this.show1 = true
				} else {
					this.show1 = false
				}
				this.n1 = i
				this.form1.name = obj.name
			},
			check2(i, obj) {
				if (obj.name == '拜访名称') {
					this.show2 = true
				} else {
					this.show2 = false
				}
				this.n2 = i
				this.form2.name = obj.name
			},
			check3(i, obj) {
				if (obj.name == '拜访名称') {
					this.show3 = true
				} else {
					this.show3 = false
				}
				this.n3 = i
				this.form3.name = obj.name
			},

			handleClick(tab, event) {
				if (tab.index == 0) {
					this.n = 0
					this.form.name = this.formdata[0].name
				} else if (tab.index == 1) {
					this.n1 = 0
					this.form1.name = this.formdata1[0].name
				} else if (tab.index == 2) {
					this.n2 = 0
					this.form2.name = this.formdata2[0].name
				} else if (tab.index == 3) {
					this.n3 = 0
					this.form3.name = this.formdata3[0].name
				}
			},

			filterTime(time) {
				var date = new Date(time);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? "0" + m : m;
				var d = date.getDate();
				d = d < 10 ? "0" + d : d;
				var h = date.getHours();
				h = h < 10 ? "0" + h : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? "0" + minute : minute;
				var s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return h + ":" + minute;
			}

		}
	};
</script>

<style lang="scss" scoped>
	.formcontent {
		display: flex;

		.left {
			flex: 0 0 50%;

			.from {
				background: rgba(244, 248, 251, 1);
				padding: 50px;
				cursor: pointer;
				div{
					background: #fff;
					padding:10px 20px;
					border-bottom:1px solid #f1f1f1 ;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
				// .active {
				// 	background: #fff;
				// }
			}

			.title {
				height: 50px;
				line-height: 50px;
				background: #fff;
				text-align: center;
			}
		}

		.right {
			flex: 0 0 50%;

			.title {
				height: 50px;
				line-height: 50px;
				background: #fff;
				text-align: center;
			}
		}
	}

	.account-config-card {
		background: #fff;
		padding: 32px;
		border-radius: 10px;
		padding-bottom: 50px;


	}

	.tb {
		width: 600px;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		border: 1px solid rgba(217, 217, 217, 1);
		padding: 0 10px;
		background: rgba(250, 250, 250, 1);
	}

	.tbody {
		border-left: 1px solid rgba(217, 217, 217, 1);
		border-right: 1px solid rgba(217, 217, 217, 1);
		width: 600px;

		.tr {
			padding: 0 10px;
			display: flex;
			border-bottom: 1px solid rgba(217, 217, 217, 1);
			align-items: center;

			.name {
				flex: 0 0 40%;
				padding: 10px 0;
			}

			.val {
				flex: 0 0 70%;
				padding-left: 10px;
				border-left: 1px solid rgba(217, 217, 217, 1);
				padding: 10px;

			}

			.tab {
				width: 340px;
				height: 40px;
				display: flex;
				align-items: center;
				border-top: 1px solid rgba(217, 217, 217, 1);
				border-left: 1px solid rgba(217, 217, 217, 1);
				border-right: 1px solid rgba(217, 217, 217, 1);
			}
		}
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.compare {
		color: red;
		text-decoration: line-through;
	}

	.ellipsis {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.el-popover {
		height: 150px;
		overflow: auto;
	}
</style>
